// Base pública do site — usada em links que serão ABERTOS FORA do app
// (convites compartilhados via WhatsApp/e-mail, acEIToS num navegador).
//
// Problema que resolve: no app (Capacitor/WebView) `location.origin` é
// `https://localhost` (ou `capacitor://localhost` no iOS) — inútil pra alguém
// clicar de fora. Nos builds do app definimos `VITE_SITE_BASE_URL` (staging ou
// produção); no site, a var é vazia e caímos em `location.origin` (correto,
// funciona em qualquer domínio onde o site rode).

export function siteBaseUrl() {
  const base = import.meta.env.VITE_SITE_BASE_URL;
  if (base) return String(base).replace(/\/+$/, '');
  return (typeof location !== 'undefined' && location.origin) || '';
}

/** Monta a URL pública de um convite a partir do token. */
export function inviteUrl(token) {
  return `${siteBaseUrl()}/invite.html?token=${token}`;
}
